import {ReportMetric} from './report-metric.enum';
import {Operator} from './operator.enum';
export class ReportPredicate {
  metric: ReportMetric;
  operator: Operator;
  condition: number;
}
